import { useRef, useState, type ReactNode } from 'react';
import { Info } from 'lucide-react';
import { Button, Popover, PopoverContent, PopoverTrigger } from '@shigo-ui/ui';

export function DashboardTableNameCell({ children }: { children: ReactNode }) {
  const content = useRef<HTMLDivElement>(null);
  const [name, setName] = useState('');
  return (
    <div className="flex min-w-0 items-center gap-1">
      <div ref={content} className="min-w-0 flex-1 truncate">
        {children}
      </div>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-8 w-8 shrink-0 sm:hidden"
            aria-label="Show full name"
            onClick={() => {
              setName(content.current?.textContent ?? '');
            }}
          >
            <Info className="h-4 w-4" aria-hidden="true" />
          </Button>
        </PopoverTrigger>
        <PopoverContent
          onClick={(event) => {
            event.stopPropagation();
          }}
          onKeyDown={(event) => {
            event.stopPropagation();
          }}
          onAuxClick={(event) => {
            event.stopPropagation();
          }}
          aria-label="Full name"
          align="start"
          className="w-max max-w-[calc(100vw-2rem)] p-3 text-sm [overflow-wrap:anywhere] whitespace-normal"
        >
          {name}
        </PopoverContent>
      </Popover>
    </div>
  );
}
